let editorRouteRequest: Promise<typeof import("../pages/EditorRoute")> | null = null;

/**
 * Keeps the editor chunk request shared between route rendering and dashboard
 * preloading. The production bundle is deliberately large, so starting this
 * download while the user is still choosing a project removes the otherwise
 * blank wait after clicking one.
 */
export function loadEditorRoute(): Promise<typeof import("../pages/EditorRoute")> {
  editorRouteRequest ??= import("../pages/EditorRoute").catch((error: unknown) => {
    editorRouteRequest = null;
    throw error;
  });
  return editorRouteRequest;
}

export function preloadEditorRoute(): void {
  void loadEditorRoute().catch(() => undefined);
}
